// Module
var code = "<div class=\"ToolBarPreview\"> <label data-bind=\"attr: { title: Label }\"> <i class=\"fa fa-file-text\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;